// TODO: This reexport is a temporary workound to not break the existing imports. It should be removed in the future with the refactor of the useTranslationPrefix hook.
// In case you will see compilation errors reloading typesript server should fix them.
export * from '../../shared/hooks/useTranslationPrefix'
